$('.section-featured-collection .collection-listing .product-list').each(function() {
  var prevArrow = $(this).closest('.collection-listing').find('.slick-button-custom--prev');
  var nextArrow = $(this).closest('.collection-listing').find('.slick-button-custom--next');
  
  $(this).slick({
    autoplay: false,
    infinite: false,
    dots: true,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '20px'
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '10px'
        }
      }
    ]
  });
});
